import React from 'react';

import { QRCodeSVG } from 'qrcode.react';

import styles from './referralQRCode.module.css';
import { PaysendLogoGlobeIcon } from './referralQRCodeIcons';

const decodeIfEncoded = (url) => {
    try {
        return decodeURIComponent(url);
    } catch {
        return url;
    }
};

const ReferralQRCode = ({ sharedLink, size = 200 }) => {
    if (!sharedLink) {
        return null;
    }
    const qrValue = decodeIfEncoded(sharedLink);

    return (
        <div className={styles.qrWrapper}>
            <QRCodeSVG value={qrValue} level="H" size={size} bgColor="#ffffff" fgColor="#000000" />
            <div className={styles.logoContainer}>
                <PaysendLogoGlobeIcon size={32} />
            </div>
        </div>
    );
};

export default ReferralQRCode;
